<script setup lang="ts">
import { provide, ref } from 'vue'
import { Repl, Preview } from '@vue/repl'
import Header from './components/Header.vue'
import PreviewControls from './components/PreviewControls.vue'
import { useStore } from './composables/store'
import { createAlert } from './composables/alert'

const state = useStore()

const searchParams = new URLSearchParams(location.search)
const preview = ref(searchParams.get('preview') === 'true')
const showControls = ref(searchParams.get('hide-controls') !== 'true')

const { Alert } = createAlert()

state.store.init()

provide('store', state.store)
provide('clear-console', ref(false))
</script>

<template>
  <v-app full-height>
    <template v-if="preview">
      <Preview
        :show="true"
        :ssr="state.ssr.value"
      />
      <PreviewControls
        v-if="showControls"
        :state="state"
      />
    </template>
    <template v-else>
      <Alert />
      <Header :state="state" />
      <v-main>
        <Repl
          :store="state.store"
          :clear-console="false"
          :show-compile-output="false"
          :ssr="state.ssr.value"
          auto-resize
          @keydown.ctrl.s.prevent
          @keydown.meta.s.prevent
        />
      </v-main>
    </template>
  </v-app>
</template>

<style>
  html {
    overflow-y: hidden !important;
  }
  .vue-repl {
    height: calc(100vh - var(--v-layout-top));
  }
</style>
